export type AlienAnimation = {
	id: string;
	idleAnimation: object;
	irritatedAnimation: object;
	correctAnimation: object;
	wrongAnimation: object;
};

export enum TimeQuestionType {
	DigitalToAnalog = 'DigitalToAnalog',
	AnalogToDigital = 'AnalogToDigital',
	TextToAnalog = 'TextToAnalog',
	TextToDigital = 'TextToDigital',
}
